import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BaseRepository } from './base.repository';
import { IDelivery, IDeliveryChange } from '../interfaces/IDelivery';

@Injectable()
export class DeliveryRepository extends BaseRepository {

    constructor(tokenHttp: TokenHttp) { 
        super(tokenHttp);
    }

    public getById(id: string): Observable<IDelivery> {
        return this.mapGet("tours/plantToDepot/" + id + "/delivery/info");
    }

    public change(id: string, change: IDeliveryChange): Observable<IDelivery> {
        return this.mapPut("tours/plantToDepot/" + id + "/delivery/change", change);
    }



}